import React, { useRef } from 'react'
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
  const features = [
    {
      title: "Experienced & Skilled Team",
      desc: "Our experienced professionals deliver high-quality construction and renovation services with precision and expertise.",
    },
    {
      title: "High-Quality Workmanship",
      desc: "We focus on superior craftsmanship and durable finishes to ensure outstanding results on every project.",
    },
    {
      title: "Transparent Pricing",
      desc: "We provide clear and honest pricing with no hidden costs, giving you complete confidence from start to finish.",
    },
    {
      title: "Reliable Project Management",
      desc: "Our team carefully manages every stage of the project to ensure smooth execution and successful completion.",
    },
    {
      title: "On-Time Completion",
      desc: "We work efficiently and professionally to complete projects within the agreed timeline without compromising quality.",
    },
    {
      title: "Customer-Focused Service",
      desc: "Your satisfaction is our priority, and we tailor every project to meet your specific needs and vision.",
    },
    {
      title: "Attention to Detail",
      desc: "We pay close attention to every detail to deliver clean, precise, and high-quality finishes.",
    },
    {
      title: "Professional & Friendly Support",
      desc: "Our team provides helpful communication and dedicated support throughout the entire renovation process.",
    },

    
  ];
function Steps() {
    const scrollContainerRef = useRef();

    const scrollByCard = (direction) => {
      const container = scrollContainerRef.current;
      const cardWidth = container.firstChild.offsetWidth + 16; // 16px margin
      container.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
    };
    const scrollRef = useRef(null);

    const scrollBy = (offset) => {
      if (scrollRef.current) {
        scrollRef.current.scrollBy({ top: offset, behavior: 'smooth' });
      }
    };
  return (
    <div>
       <div className="relative w-full h-auto bg-black text-white overflow-hidden">
            {/* Background Video */}
            <video
              autoPlay
              loop
              muted
              playsInline
              className="absolute top-0 left-0 w-full h-full object-cover z-0"
            >
              <source src="/assets/videos/investor-rise-bg-map.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
      
            {/* Overlay */}
            <div className="relative z-10 bg-black/30 w-full">
              <div className="flex flex-col md:flex-row items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10">
      
                {/* Left Section: Heading + Frame + Description + Button */}
                <div className="md:w-1/2 w-full text-center md:text-left relative">
                  {/* Frame on Top Left */}
                  <motion.div
                    animate={{ y: [0, -12, 5, 0] }}
                    transition={{ repeat: Infinity, duration: 3 }}
                    className="absolute -top-8 -left-2 md:-left-8 w-[70px] h-[80px] border-t-[22px] border-l-[22px] border-teal-600 opacity-35 "
                  />
                  <motion.h1
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1.3, delay:0.5 }}
                    viewport={{ once: true }}
                    className="text-4xl sm:text-5xl font-bold mb-4 text-white "
                  >
                    ABOUT US
                  </motion.h1>
      
                  <motion.p 
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1.3, delay:0.5 }}
                  viewport={{ once: true }}
                  className="text-white/80 text-base sm:text-xl mb-6 max-w-md mx-auto md:mx-0">
                 We are a trusted construction and renovation company committed to helping homeowners improve and transform their properties with professional building services. Whether you are planning a modern kitchen renovation, expanding your living space with a house extension, or upgrading your bathroom, our experienced team delivers outstanding results with precision and care.
                  </motion.p>

      <Link to="/contact" >
                  <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold bg-teal-600 shadow-xl text-lg group">
                    <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-tslate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
                    <span className="relative z-10">Contact Us</span>
                  </button></Link>
                </div>
      
                {/* Right Section: Scrollable Features */}
                <div className="md:w-1/2 w-full relative flex flex-col items-center">
                  {/* Scroll Up Button */}
                  <button
                    onClick={() => scrollBy(-180)}
                    className="mb-2 text-sm bg-white/20 hover:bg-white/30 px-4 py-2 rounded-full transition"
                  >
                    ↑
                  </button>
      
                  {/* Scrollable Box: Show 3 items height, scroll rest */}
                  <div
                    ref={scrollRef}
                    className="h-[540px] overflow-y-scroll no-scrollbar w-full px-4 space-y-8"
                  >
                    {features.map((item, idx) => (
                      <div key={idx} className="bg-white/10 p-4 rounded-lg shadow-md py-10">
                        <h3 className="text-2xl font-semibold text-teal-300 mb-2">{item.title}</h3>
                        <p className="text-base sm:text-lg text-white">{item.desc}</p>
                      </div>
                    ))}
                  </div>
      
                  {/* Scroll Down Button */}
                  <button
                    onClick={() => scrollBy(180)}
                    className="mt-2 text-sm bg-white/20 hover:bg-white/25 px-4 py-2 rounded-full transition"
                  >
                    ↓
                  </button>
                </div>
              </div>
            </div>
          </div>
    </div>
  )
}

export default Steps
